module.exports = __webpack_public_path__ + "static/media/align-justify.fefb7f4f.svg";